/*
 * @Author: Suroc
 * @Date: 2024-07-11 14:15:56
 * @LastEditTime: 2025-01-11 22:54:47
 * @Description: 
 */
const ms = {
  // 头部导航
  Header: {
    SuperMarket: "CCR LAND",
    Connect: "Sambung Dompet",
  },
  // 底部导航
  Footer: {
    Home: "Laman Utama",
    Mining: "Ladang",
    Profit: "Perdagangan",
    Flst: "NFT",
    Team: "Halaman Saya",
  },
  // 首页
  Home: {
    Account: "Akaun",
    Share: "Kongsi",
    Reference: "Penaja",
    BindWallet: "Sila ikat dompet terlebih dahulu",
    Ecological: "Mesin Perlombongan",
    Pledge: "Stak",
    Conduct: "Pengurusan Aset",
    ToLoan: "Pinjaman",
    Metaverse: "Metaverse",
    ChainGame: "Permainan Rantai",
    ShoppingMall: "Pusat Beli-belah",
    SwapBut: "Jelajah",
  },
  // 矿机
  Mint: {
    OnSale: "Sedang Dijual",
    StopSelling: "Henti Jualan",
    F1MiningMachine: "Mesin Perlombongan F1",
    F2MiningMachine: "Mesin Perlombongan F2",
    F3MiningMachine: "Mesin Perlombongan F3",
    F4MiningMachine: "Mesin Perlombongan F4",
    F5MiningMachine: "Mesin Perlombongan F5",
    Authorize: "Kebenaran",
    BuyNow: "Beli Sekarang",
    PurchaseFLST: "Beli FLST",
  },
  // 收益
  Profit: {
    Hold: "Nilai Mesin Dimiliki",
    UnStatic: "Keuntungan Statik Belum Diterima",
    UnDynamics: "Keuntungan Dinamik Belum Diterima",
    StaticTotal: "Jumlah Keuntungan Statik (Sudah Diterima)",
    DynamicTotal: "Jumlah Keuntungan Dinamik (Sudah Diterima)",
    MyIncome: "Jumlah Keuntungan",
    Receive: "Terima",
    MyRecord: "Rekod Keuntungan Saya",
    Money: "Jumlah (U)",
    Quantity: "Bilangan Token",
    Time: "Masa",
  },
  // 团队
  Team: {
    SuperiorAddress: "Alamat Atasan",
    Performance: "Prestasi Saya",
    TeamSize: "Bilangan Ahli Pasukan",
    Referral: "Bilangan Rujukan Langsung",
    Direct: "Pasukan Saya",
    Address: "Alamat",
    Money: "Jumlah (U)",
    Time: "Masa",
    CopyLink: "Salin Pautan",
  },
  // 公共消息弹窗
  Prompt: {
    Admin: "Tiada Kebenaran Akses",
    AdminInfo: "Ralat Pengambilan",
    AdminModified: "Pengubahan Berjaya",
    AdminModification: "Pengubahan Gagal",
    PurchaseSucceeded: "Pembelian Berjaya",
    PurchaseFailed: "Pembelian Gagal",
    BindingSucceeded: "Pengikatan Berjaya",
    BindingFailed: "Pengikatan Gagal",
    ConnectWallet: "Sila sambung dompet terlebih dahulu",
    Confirm: "Sahkan",
    Cancel: "Batal",
    GoGetIt: "Pergi Terima",
    SoldOut: "Habis Dijual",
    NotYetDev: "Belum Dibuka",
    NewIssueSuccess: "Penerimaan Berjaya",
    NewIssueError: "Penerimaan Gagal",
    TransactionErr: "Transaksi Gagal",
    BalanceErr: "Baki Tidak Mencukupi",
    USDTBalanceErr: "Baki USDT Tidak Mencukupi",
    FLSTBalanceErr: "Baki FLST Tidak Mencukupi",
    AllowanceErr: "Kebenaran Tidak Mencukupi",
    AllowanceSuccess: "Kebenaran Berjaya",
    InviteInfo1: "Anda melalui",
    InviteInfo2: "jemputan untuk melawat, adakah anda ingin mengikat hubungan?",
    ProfitInfo: "Anda mempunyai keuntungan yang belum diterima, sila terima sebelum membeli",
    ProfitInfo2: "Anda tidak mempunyai keuntungan yang belum diterima",
    Fail: "Ralat",
  },
  nongC: {
    Home: "Laman Utama",
    Farm: "Ladang",
    Trade: "Perdagangan",
    NFT: "NFT",
    Mine: "Halaman Saya",
    Share: "Kongsi",
    Referrer: "Penaja",
    Lv: "Tahap Semasa",
    Bal: "Baki",
    CHZSoil: "Tanah Kalsium Hitam",
    KSTSoil: "Tanah Kalsium Coklat",
    SRZSoil: "Tanah Kalsium Perang",
    GRZSoil: "Tanah Kalsium Kelabu",
    Plant: "Tanam",
    Harvest: "Tuai",
    Buy: "Beli",
    TaxRt: "Kadar Cukai",
    Prc: "Harga",
    Qty: "Kuantiti",
    Mkt: "Pasaran",
    Mint: "Cipta",
    BBox: "Kotak Buta",
    BuyBBox: "Beli Kotak Buta",
    SellOrder: "Pesanan Jual",
    SellMarket: "Senarai Jual",
    Cancel: "Batal",
    Claim: "Terima",
    ContriDiv: "Dividen Sumbangan (Diterima Secara Proksi)",
    EquityDiv: "Dividen Ekuiti (Diterima Secara Proksi)",
    EquityVal: "Nilai Ekuiti",
    ContriVal: "Nilai Sumbangan",
    DivList: "Senarai Dividen",
    MyTeam: "Pasukan Saya",
    MyDown: "Barisan Bawahan",
    MyUpss: "Barisan Atasan",
    TeamMaxLv: "Tahap Tertinggi Pasukan",
    DirectRefPerf: "Prestasi Rujukan Langsung",
    Bind: "Ikat",
    Sale: "Jual",
    HistoryPrice: "Harga Sejarah",
    Error: "Ralat",
  },
  common: {
    crzfh: "Dividen Pensijilan C",
    contri: "Dividen Sumbangan",
    contriAmount: "Jumlah Dividen",
    myArea: "Kawasan Saya",
    myBind: "Pengikatan Saya",
    noBind: "Tiada Pengikatan",
    ktAdress: "Alamat Pembukaan",
    crz: "Pensijilan C",
    qyz: "Nilai Ekuiti",
    none: "Tiada",
    payAmount: "Kuantiti Pembayaran",
    sale: "Jual",
    amount: "Kuantiti",
    investment: "Pelaburan",
    released: "Dilepaskan",
    cycle: "Kitaran",
    plantTime: "Masa Menanam",
    lastHarvest: "Tuai Terakhir",
    harvest: "Tuai",
    hgt: "Tanah Kalsium Hitam",
    lgt: "Tanah Kalsium Coklat",
    zgt: "Tanah Kalsium Perang",
    huigt: "Tanah Kalsium Kelabu",
    plantNow: "Tanam Sekarang",
    makeSure: "Sahkan",
    czzqsh: "Sedang diproses, sila tunggu...",
    ljqdts: "Jumlah hari daftar masuk:",
    dh: "Tukar",
    wqd: "Belum Daftar Masuk",
    dqd: "Menunggu Daftar Masuk",
    kfzqdd: "Sedang dibangunkan, sila tunggu",
    gqbzwjrqx: "Dompet ini tiada kebenaran akses",
    zwkf: "Belum Dibuka",
    sqcg: "Kebenaran Berjaya",
    sqsb: "Kebenaran Gagal",
    zzcg: "Penciptaan Berjaya",
    zzsb: "Penciptaan Gagal",
    dkcg: "Pembukaan Berjaya",
    dksb: "Pembukaan Gagal",
    cg: "Berjaya",
    sb: "Gagal",
    open: "Buka",
    buy: "Beli",
    free: "Percuma",
    zzhqsj: "Sedang mendapatkan data",
    zwtjr: "Tiada Penaja",
    destroy: "Musnah",
    sywcc: "Baki Belum Dihasilkan",
    dhfm: "10 Hari 23 Jam 15 Minit 15 Saat",
    xcrq: "Tarikh Seterusnya",
    zwzsdnft: "Tiada NFT untuk Dijual",
    mc: "Nama:",
    fortyfiveDay: "50 Hari",
    token: "Token",
    price: "Harga", 
    total: "Jumlah",
    uybind: "Adakah anda ingin mengikat",
    zgyqmm: "kod jemputan ini?",
    zwyqm: "Tiada Kod Jemputan",
    wcxdyqm: "Kod jemputan tidak ditemui",
    bindSuccess: "Pengikatan Selesai",
    zwkf: "Belum Dibuka",
    lq: "Terima",
    fail: "Gagal",
    mygdl: "Tiada Lagi",
    jine: "Jumlah:",
    shijian: "Masa:",
    tq: "Pengeluaran",
    tqd: "Telah Dikeluarkan",
    dsf: "Menunggu Pelepasan",
    zzsf: "Sedang Melepaskan",
    sfwc: "Pelepasan Selesai",
    jz: "Nilai:",
    zz: "Tanam",
    zq: "Kitaran",
    Hour: "Jam",
    Day: "Hari",
    Min: "Minit",
    Sec: "Saat",
    limit: "Baki Tersedia",
    tq: "Curi",
  },
};

export default ms;